var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    {
      staticClass: "row",
      class: {
        selected: _vm.isSelected,
        bold: _vm.isBold,
        hidden: _vm.isHidden,
      },
    },
    [
      _c("td", { style: { width: _vm.getWidth("qty") } }, [
        _vm.row.Duration
          ? _c("span", [
              _vm._v(" " + _vm._s(_vm.humanDuration(_vm.row.Duration)) + " "),
            ])
          : _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.humanFloat(_vm.row.Amount1, _vm.decimalSettings.Qty)
                  ) +
                  " "
              ),
            ]),
      ]),
      _vm.showQty2
        ? _c("td", { style: { width: _vm.getWidth("qty2") } }, [
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.humanFloat(_vm.row.Amount2, _vm.decimalSettings.Qty2)
                  ) +
                  " "
              ),
            ]),
          ])
        : _vm._e(),
      !_vm.hideUnits
        ? _c("td", { style: { width: _vm.getWidth("unit") } }, [
            _vm._v(" " + _vm._s(_vm.row.UnitName) + " "),
          ])
        : _vm._e(),
      _c("td", { style: { width: _vm.getWidth("sku") } }, [
        _vm._v(_vm._s(_vm.row.ProductSku)),
      ]),
      _c(
        "td",
        {
          staticClass: "description",
          class: { noSku: !_vm.row.ProductSku },
          staticStyle: { overflow: "hidden" },
          style: { width: _vm.getWidth("description") },
        },
        [
          _c("span", {
            directives: [
              {
                name: "safe-html",
                rawName: "v-safe-html",
                value: _vm.displayedProductDescription,
                expression: "displayedProductDescription",
              },
            ],
          }),
        ]
      ),
      _c(
        "td",
        {
          staticClass: "align-r",
          style: { width: _vm.getWidth("unit-price") },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.humanFloat(
                  _vm.row.UnitPrice / _vm.currencyRate,
                  _vm.decimalSettings.Unit
                )
              ) +
              " "
          ),
        ]
      ),
      _c(
        "td",
        { staticClass: "align-r", style: { width: _vm.getWidth("discount") } },
        [
          _vm._v(
            " " +
              _vm._s(_vm.humanFloat(_vm.row.Discount / _vm.currencyRate, 2)) +
              " "
          ),
        ]
      ),
      _c(
        "td",
        { staticClass: "align-r", style: { width: _vm.getWidth("vat") } },
        [_vm._v(" " + _vm._s(_vm.humanFloat(_vm.row.Vat, 1)) + " ")]
      ),
      _c(
        "td",
        { staticClass: "align-r", style: { width: _vm.getWidth("netto") } },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.humanFloat(
                  _vm.netto / _vm.currencyRate,
                  _vm.decimalSettings.Unit
                )
              ) +
              " "
          ),
        ]
      ),
      _c(
        "td",
        { staticClass: "align-r", style: { width: _vm.getWidth("bruto") } },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.humanFloat(
                  _vm.bruto / _vm.currencyRate,
                  _vm.decimalSettings.Unit
                )
              ) +
              " "
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }